export function Hero() {
  return (
    <section className="min-h-screen bg-[#111820] flex items-center px-8 lg:px-12 pt-[120px] pb-20 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute w-[60%] h-[50%] top-1/2 left-[70%] -translate-x-1/2 -translate-y-1/2 bg-[#2E7D4F]/12 rounded-full blur-[120px]" />
        <div className="absolute w-[40%] h-[60%] top-[80%] left-[20%] -translate-x-1/2 -translate-y-1/2 bg-[#3B4A5A]/20 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-[1200px] mx-auto w-full grid lg:grid-cols-2 gap-20 items-center relative z-10">
        <div>
          <div className="inline-flex items-center gap-2 bg-[#2E7D4F]/15 border border-[#2E7D4F]/30 rounded-[2px] px-[14px] py-[6px] mb-7">
            <span className="w-[6px] h-[6px] bg-[#3B9B63] rounded-full animate-pulse" />
            <span className="text-[11px] font-semibold tracking-[0.14em] uppercase text-[#3B9B63]">
              Oklahoma · Oil & Gas
            </span>
          </div>

          <h1
            className="text-[clamp(42px,5vw,64px)] font-bold leading-[1.08] text-white mb-6 tracking-[-0.02em]"
            style={{ fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif" }}
          >
            Deals move fast.
            <br />
            <span className="text-[#3B9B63]">LandTrack</span> does too.
          </h1>

          <p className="text-[17px] text-white/60 leading-[1.7] font-light mb-11 max-w-[480px]">
            Purpose-built inventory tracking for oil & gas acquisition companies. Stay organized,
            move fast, and never lose track of what you own.
          </p>

          <div className="flex gap-4 flex-wrap items-center">
            <a
              href="#contact"
              className="inline-block px-8 py-[14px] bg-[#2E7D4F] hover:bg-[#3B9B63] text-white rounded font-semibold text-[14px] tracking-[0.04em] transition-all hover:-translate-y-[1px]"
            >
              Request Access <span>→</span>
            </a>
            {/* <a
              href={loginUrl}
              className="inline-block px-8 py-[14px] bg-[#2E7D4F] hover:bg-[#3B9B63] text-white rounded font-semibold text-[14px] tracking-[0.04em] transition-all hover:-translate-y-[1px]"
            >
              Access Login
            </a>
            <a href="#contact" className="inline-flex items-center gap-[6px] text-white/70 hover:text-white text-[14px] font-medium transition-colors">
              Request Access <span>→</span>
            </a> */}
          </div>

          <div className="flex gap-10 mt-14 pt-9 border-t border-white/[0.08]">
            {[
              { val: "Real-time", label: "Updates" },
              { val: "Single", label: "Source of Truth" },
              { val: "Fast", label: "& Organized" },
            ].map((s) => (
              <div key={s.label}>
                <div
                  className="text-[32px] font-bold text-white leading-none"
                  style={{ fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif" }}
                >
                  {s.val}
                </div>
                <div className="text-[12px] text-white/45 tracking-[0.08em] uppercase mt-1 font-medium">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 pl-6 py-5 border-l-2 border-[#2E7D4F] bg-white/[0.03] rounded-r-md max-w-[480px]">
            <p className="text-[13px] text-white/55 leading-[1.7] italic font-light mb-[10px]">
              "We were moving too fast to keep up with what we actually owned. LandTrack became our
              single source of truth — organized, current, and exactly what we needed."
            </p>
            <span className="text-[11px] text-white/30 font-medium tracking-[0.06em] uppercase">
              — Oklahoma Acquisition Company
            </span>
          </div>
        </div>

        <div className="bg-[#1A2332] border border-white/[0.08] rounded-xl overflow-hidden">
          <div className="bg-[#232F3E] px-5 py-[14px] flex items-center justify-between border-b border-white/[0.06]">
            <span className="text-[12px] font-semibold tracking-[0.1em] uppercase text-white/50">
              Master Inventory
            </span>
            <span className="bg-[#2E7D4F]/20 border border-[#2E7D4F]/40 text-[#3B9B63] text-[10px] font-semibold tracking-[0.1em] uppercase px-[10px] py-[3px] rounded-[2px]">
              Live
            </span>
          </div>
          <div className="p-5">
            <div className="grid grid-cols-5 gap-3 pb-3 border-b border-white/[0.06] mb-3">
              {["S-T-R", "County", "Net Acres", "NRI", "Operator"].map((h, i) => (
                <span
                  key={h}
                  className={`text-[11px] font-semibold text-white/40 uppercase tracking-wider${i === 2 || i === 3 ? " text-right" : ""}`}
                >
                  {h}
                </span>
              ))}
            </div>
            {[
              { str: "14-15N-15W", county: "Custer", acres: "141.82", nri: ".7500", op: "Mach" },
              { str: "07-11N-09W", county: "Caddo", acres: "80.00", nri: ".8125", op: "Devon" },
              {
                str: "22-16N-17W",
                county: "Dewey",
                acres: "53.25",
                nri: ".7500",
                op: "Continental",
              },
              {
                str: "31-17N-25W",
                county: "R. Mills",
                acres: "320.00",
                nri: ".8750",
                op: "SandRidge",
              },
              {
                str: "23-13N-19W",
                county: "Beckham",
                acres: "118.69",
                nri: ".7500",
                op: "Citizen",
              },
            ].map((row, i) => (
              <div
                key={i}
                className="grid grid-cols-5 gap-3 py-2 text-[13px] text-white/70 hover:bg-white/[0.02] rounded transition-colors"
              >
                <span className="font-mono font-semibold text-[#3B9B63]">{row.str}</span>
                <span>{row.county}</span>
                <span className="font-mono text-right">{row.acres}</span>
                <span className="font-mono text-right">{row.nri}</span>
                <span className="text-white/50 text-[12px]">{row.op}</span>
              </div>
            ))}
          </div>
          <div className="px-5 py-[14px] bg-white/[0.02] border-t border-white/[0.05] flex items-center gap-2">
            <span className="text-[11px] text-white/30">Total Properties:</span>
            <strong className="text-[11px] text-[#3B9B63] font-semibold">2,847</strong>
            <span className="text-[11px] text-white/20 ml-2">·</span>
            <span className="text-[11px] text-white/30">Last Updated:</span>
            <strong className="text-[11px] text-white/50 font-medium">2 min ago</strong>
          </div>
        </div>
      </div>
    </section>
  )
}
